import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import Modal from 'react-modal';

import i18nFunct from '../../utils/i18n';
import './bounce-detection.scss';

interface Props {
  children: ReactNode;
  forceBounce?: boolean;
  i18nKey?: string;
}

const BounceDetection: FC<Props> = ({
  children,
  forceBounce = false,
  i18nKey = 'en'
}) => {
  const [bounced, setBounced] = useState(forceBounce || false);
  const loadDelay = 2000;

  const { i18nData } = useStaticQuery(
    graphql`
      {
        i18nData: allFile(filter: { sourceInstanceName: { eq: "i18n" } }) {
          edges {
            node {
              name
              childSrcJson {
                mktg_bounce_detection_rejection
              }
            }
          }
        }
      }
    `
  );

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const bounceback = require('../../utils/bounceback');
    window.setTimeout(() => {
      bounceback.enable();
      bounceback.init({
        onBounce: () => {
          setBounced(true);
          if (window && window.lucid && window.lucid.kissMetrics) {
            window.lucid.kissMetrics.set({ '[website] bounce saw dialog': 1 });
          }
          return bounceback;
        },
        cookieLife: 3,
        storeName: 'exit-intent-marketing',
        delay: 500
      });
    }, loadDelay);

    return () => {
      bounceback.disable();
    };
  }, []);

  const closeBounceDetection = () => {
    setBounced(false);
  };

  const i18n = i18nFunct(i18nData, i18nKey);

  Modal.setAppElement('body');

  return (
    <Modal
      className="bounce-detection-wrapper"
      overlayClassName="bounce-detection-overlay"
      isOpen={bounced}
      onRequestClose={closeBounceDetection}
      shouldCloseOnOverlayClick
    >
      <aside
        className="bounce-detection"
        data-reject={i18n('mktg-bounce-detection-rejection')}
      >
        <>
          <button
            className="bounce-detection__close"
            type="button"
            onClick={closeBounceDetection}
          >
            ×
          </button>
          {children}
        </>
      </aside>
    </Modal>
  );
};

export default BounceDetection;
